const initialState = {
  operationType: [
    { uniqId: 1, displayName: "All", value: "" },
    { uniqId: 2, displayName: "Inter City", value: "Inter" },
    { uniqId: 3, displayName: "Intra City", value: "Intra" },
  ],
  selectedOperationType: "",
};
export default initialState;
